export const buildFormData = (entries) => {
  const formData = new FormData();
  entries.forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });
  return formData;
};

export const buildCapturedContentFormData = (file, avpsIotRequest) => (
  buildFormData([
    ["file", file],
    ["avpsIotRequest", JSON.stringify(avpsIotRequest)]
  ])
);

export const buildIotContentFormData = (file, companyCode, type, primaryId) => (
  buildFormData([
    ["file", file],
    ["companyCode", companyCode],
    ["type", type],
    ["primaryId", primaryId]
  ])
);

export const buildIotContentPartFormData = (videoChunk, primaryId) => (
  buildFormData([
    ["videoChunk", videoChunk],
    ["primaryId", primaryId]
  ])
);

export const buildProcessVideoFormData = (companyCode, type, primaryId) => (
  buildFormData([
    ["companyCode", companyCode],
    ["type", type],
    ["primaryId", primaryId]
  ])
);

export const buildPreSignedUrlRequest = (key) => ({ key });
